// NOTE: 同じ対応表が app/services/ag_prefill_service.rb の EXPERIENCE_TO_USER_EXPERIENCE_YEARS にもある。
// あちらは全角数字の実データも引けるようにしてあり、年数が分からない「あり」は転記対象から
// 外している。片方を直すときは両方を見ること
export const EXPERIENCE_TO_EXPERIENCE_YEARS_MAP: Record<string, string> = {
    なし: 'less_than_one_year',
    あり: 'less_than_one_year',
    '1年': 'one_to_five_years',
    '2年': 'one_to_five_years',
    '3年': 'one_to_five_years',
    '4年': 'one_to_five_years',
    '5年': 'one_to_five_years',
    '6年': 'five_to_ten_years',
    '7年': 'five_to_ten_years',
    '8年': 'five_to_ten_years',
    '9年': 'five_to_ten_years',
    '10年以上': 'more_than_ten_years',
} as const

export const SITUATION_NUMBER_TO_STRING_MAP: Record<number, string> = {
    10: 'tenure',
    20: 'resignation',
} as const

export const SITUATION_STRING_TO_DISPLAY_MAP: Record<string, string> = {
    tenure: '在職中',
    resignation: '離職中',
} as const

export const SITUATION_NUMBER_TO_DISPLAY_MAP: Record<number, string> = {
    10: '在職中',
    20: '離職中',
} as const
